// extracted by mini-css-extract-plugin
export default {"root":"style_root__eSWcJ","expired":"style_expired__eYkMV","info":"style_info__KhKkX","status":"style_status__AkUWg","iconWrap":"style_iconWrap__WBMsF","icon":"style_icon__LzXJ2"};